import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { CssBaseline, GlobalStyles } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import vsDarkTheme from "./theme/vsDarkTheme";
import Layout from "./components/Layout";
import About from "./pages/About";
import Resume from "./pages/Resume";
import BlogProjects from "./pages/BlogProjects";
import BlogPost from "./pages/BlogPost";

export default function App() {
  return (
    <ThemeProvider theme={vsDarkTheme}>
      <CssBaseline />
      <GlobalStyles styles={{
        a: { color: 'inherit', textDecoration: 'none' },
        'a:visited': { color: 'inherit' }
      }} />
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<About />} />
            <Route path="/resume" element={<Resume />} />
            <Route path="/blog" element={<BlogProjects />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}